import { useEffect, useState, ReactNode  } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, useColorScheme } from '@mui/material';
import logoCabanaWhite from '../images/logonextcabana-white.svg';
import logoCabanaBlack from '../images/logonextcabana-dark.svg';
import AppTheme from '../shared-theme/AppTheme';
import LinearIndeterminate from '../components/LoadingLinear';

interface PrivateRouteProps {
  children: ReactNode;
  disableCustomTheme?: boolean;
}

export default function PrivateRoute(props: PrivateRouteProps) {
  return (
    <AppTheme disableCustomTheme={props.disableCustomTheme}>
       <PrivateRouteContent>{props.children}</PrivateRouteContent>
    </AppTheme>
  )
}

function PrivateRouteContent(
  { children }: { children: React.ReactNode },
) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(true);
  const { mode, systemMode } = useColorScheme();

  useEffect(() => {
    if (user) {
      setLoading(false);
      return;
    }

    if (!user) {
      const timer = setTimeout(() => {
        setShowMessage(true);
        setLoading(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [user]);

  if (loading) {
    return (
      <AppTheme>
        <LinearIndeterminate />
      </AppTheme>
    );
  }

  if (!user) {
    if (!showMessage) {
      return null;
    }
    return (
      <AppTheme>
        <Container
          component="main"
          sx={{
            maxWidth: 'xs',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '40px',
              marginBottom: '40px'
            }}
          >
            <img
              src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
              alt="logo-cabanalink"
              style={{ width: '300px', height: 'auto' }}
            />
          </div>
          <Typography variant="h5">Você não está logado no momento.</Typography>
          <Button
            onClick={() => navigate('/signin')}
            variant="contained"
            sx={{ width: '200px', alignSelf: 'center' }}
          >
            Faça o login
          </Button>
        </Container>
      </AppTheme>
    );
  }

  return <>{children}</>;
}
